import { Button, Col, Container, Row, Card } from "react-bootstrap";
import MaterialTable, { MTableAction } from "material-table";
import CustomContentAlert, { navigationButtons } from "../helper";
import AddEdgeDeviceTypeFunc from "./AddEdgeDeviceTypeFunc";
import React from "react";
import { useSelector, useDispatch, batch } from "react-redux";
import * as EdgeDeviceActions from "../../Actions/EdgeDeviceActions/action";
import * as SuperAdminAction from "../../Actions/SuperAdminAction/actions";
import styled from "styled-components";
import t from "../../Actions/EdgeDeviceActions/types";

const AddEdgeDeviceFunc = () => {
  const addActionRef = React.useRef(null);
  const [propertyId, setProertyId] = React.useState("");
  const dispatch = useDispatch();
  const deviceTypes = useSelector(
    (state) => state.EdgeDeviceDetails.deviceTypes
  );
  const selectedDeviceType = useSelector(
    (state) => state.EdgeDeviceDetails.selectedDeviceType
  );
  const edgeDevices = useSelector(
    (state) => state.EdgeDeviceDetails.edgeDevices
  );
  const apiMessage = useSelector((state) => state.EdgeDeviceDetails.message);

  const modelOpenCLose = useSelector(
    (state) => state.EdgeDeviceDetails.modelOpenClose
  );

  const properties = useSelector(
    (state) => state.SuperAdminDetails.getAllProperties
  );

  const lastSelectedType = React.useRef("");

  const ValidateDeviceType = React.useCallback(
    (rowData) => {
      if (rowData.type && rowData.type.length) {
        if (lastSelectedType.current !== rowData.type) {
          dispatch(EdgeDeviceActions.fetchFieldsForDeviceType(rowData.type));
          lastSelectedType.current = rowData.type;
          dispatch({
            type: t.CLOSE_OPEN_MODEL,
            payload: true,
          });
        }
      }
      return rowData.type === "" ? "Device cannot be empty" : "";
    },
    [dispatch, selectedDeviceType]
  );

  const EditRow = React.useCallback((rowData) => {
    dispatch({
      type: t.SET_EDGE_DEVICE_DATA,
      payload: rowData,
    });
    dispatch({
      type: t.CLOSE_OPEN_MODEL,
      payload: true,
    });
  }, []);

  const DeleteRow = React.useCallback(async (rowData) => {
    const confirmation = window.confirm(
      "Are you sure you want to delete this entry?"
    );
    if (confirmation) {
      dispatch(
        EdgeDeviceActions.deleteSelectedDevice(
          rowData.id,
          window.document.location.href.split("?")[1]
        )
      );
    }
  }, []);

  const columns = React.useRef([
    {
      title: "Device Type",
      field: "type",
      lookup: {},
      validate: ValidateDeviceType,
    },
    {
      title: "Device Name",
      field: "device_name",
      validate: (rowData) =>
        rowData.device === "" ? "Please add device name" : "",
      customSort: (a, b) =>
        a.device_name.toLowerCase() > b.device_name.toLowerCase() ? 1 : -1,
    },
    {
      title: "MAC",
      field: "mac_id",
    },
    {
      title: "Action",
      field: "-",
      // eslint-disable-next-line react/display-name
      render: (rowData) =>
        !modelOpenCLose && (
          <React.Fragment>
            <i
              className="fas fa-pen"
              aria-hidden="true"
              onClick={() => EditRow(rowData)}
            ></i>
            <i
              className="fas fa-trash pl-4"
              aria-hidden="true"
              onClick={() => DeleteRow(rowData)}
            ></i>
          </React.Fragment>
        ),
    },
  ]);

  React.useEffect(() => {
    dispatch(SuperAdminAction.get_all_properties());
  }, [dispatch]);

  React.useEffect(() => {
    const propertyId_ = window.document.location.href.split("?")[1];
    setProertyId(propertyId_);
    const selectedPropertyObj = properties.filter(
      (item) => item.id === propertyId_
    );
    const selectedPropertyName =
      selectedPropertyObj && selectedPropertyObj.length
        ? selectedPropertyObj[0].site_name
        : "";
    const selectedDomainName =
      selectedPropertyObj && selectedPropertyObj.length
        ? selectedPropertyObj[0].domain
        : "";

    dispatch(
      SuperAdminAction.setDomainHeader(selectedPropertyName, selectedDomainName)
    );
  }, [properties]);

  React.useEffect(() => {
    batch(() => {
      dispatch(EdgeDeviceActions.fetchAllDeviceTypes());
      dispatch(EdgeDeviceActions.fetchAllEdgeDevices());
    });
  }, [dispatch]);

  React.useEffect(() => {
    let timeout = null;
    if (apiMessage && apiMessage.message) {
      timeout = setTimeout(() => {
        dispatch({
          type: t.SET_EDGE_DEVICE_ERROR,
          payload: "",
        });
      }, 5000);
    }
    return () => {
      if (timeout !== null) clearTimeout(timeout);
    };
  }, [dispatch, apiMessage]);

  React.useEffect(() => {
    const deviceTypeObj = deviceTypes.reduce(function (acc, cur, i) {
      acc[cur.type] = cur.type;
      return acc;
    }, {});
    columns.current.forEach((column) => {
      if (column.lookup) {
        column.lookup = deviceTypeObj;
      }
    });
  }, [deviceTypes]);

  const modelhandle = React.useCallback(() => {
    dispatch({
      type: t.CLOSE_OPEN_MODEL,
      payload: true,
    });
  }, []);

  return (
    <>
      <Container fluid>
        <Row className="h-100">
          <Col md="12">
            <Card className="h-100">
              <Card.Header className="d-flex align-items-start justify-content-between">
                <div>
                  <Card.Title as="h4">Add Edge Device</Card.Title>
                  <p className="card-category">
                    Fill out below form to add new Edge Device.{" "}
                  </p>
                </div>
              </Card.Header>
              <Card.Body>
                <StyledDiv style={{ maxWidth: "100%" }}>
                  <MaterialTable
                    title=""
                    options={{
                      actionsColumnIndex: -1,
                      addRowPosition: "first",
                      draggable: false,
                      // sorting: true,
                      // selection: true,
                    }}
                    components={{
                      Action: (props) => {
                        if (
                          typeof props.action === typeof Function ||
                          props.action.tooltip !== "Add"
                        ) {
                          return <MTableAction {...props} />;
                        } else {
                          return (
                            <div
                              ref={addActionRef}
                              onClick={props.action.onClick}
                            />
                          );
                        }
                      },
                    }}
                    action={[
                      {
                        icon: "save",
                        isFreeIcon: true,
                        iconProps: <Button>Save</Button>,
                      },
                    ]}
                    columns={columns.current}
                    data={edgeDevices} // need to pass array containing edge devices
                    onRowClick={(rowData) => console.log("Row clicked....")}
                    onRowSelected={(rowData) =>
                      console.log("Row clionRowSelectedcked....")
                    }
                    editable={{
                      onRowAddCancelled: (rowData) =>
                        console.log("Row adding cancelled"),
                      onRowUpdateCancelled: (rowData) =>
                        console.log("Row editing cancelled"),
                      onRowAdd: (newData) =>
                        new Promise((resolve, reject) => {
                          setTimeout(() => {
                            resolve();
                          }, 1000);
                        }),
                    }}
                  />
                </StyledDiv>
                <Col lg="12" className="p-0">
                  {navigationButtons(
                    "/addcameraform",
                    "/citation-setup",
                    propertyId,
                    addActionRef,
                    "Add Edge Device",
                    null,
                    null,
                    null,
                    () => {
                      modelhandle();
                    }
                  )}
                </Col>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
      {modelOpenCLose ? (
        <AddEdgeDeviceTypeFunc
          show={modelOpenCLose}
          selectedType={selectedDeviceType}
        />
      ) : null}
      {apiMessage && apiMessage.isSuccess && apiMessage.message !== "" && (
        <CustomContentAlert
          delay={2000}
          message={apiMessage.message}
          className={apiMessage.isSuccess ? "toast-success" : ""}
        />
      )}
    </>
  );
};
export default AddEdgeDeviceFunc;
const StyledDiv = styled.div`
  max-width: 100%;
  table > thead {
    th:last-child {
      // display: none;
    }
  }
  table > tbody {
    td:last-child {
      // display: none;
    }
  }
`;
// const CustomButton = styled(Button)`
//   height: 40px;
//   width: 40px;
//   border-radius: 25px;
//   padding: 5px;
// `;
